import React from "react";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
import { FlowEditContext } from "../../FlowEditContext";
import { RenderStepStrategy } from "../CommonRender/RenderStepStrategy";

interface IStepStrategyEditDialog {
    editContext: FlowEditContext;
}

export const StepStrategyEditDialog: React.FC<IStepStrategyEditDialog> = (props: IStepStrategyEditDialog) => {
    return (
        <ObserveState
            listenTo={props.editContext}
            properties={[FlowEditContext.SHOW_STEP_STRATEGY]}
            data-testid="step-strategy-dialog"
            control={() => <RenderStepStrategy editContext={props.editContext} />}
        />
    );
};
